import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chart from "react-apexcharts";
import Grid from "@material-ui/core/Grid";
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  depositContext: {
    flex: 1,
  },
  infoLight: {
    fontFamily: "Montserrat",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    "&::before": {
      content: `'aa'`,
      width: "15px",
      height: "15px",
      backgroundColor: "#FF0000",
      marginRight: "8px",
      borderRadius: "50%",
      color: "transparent",
    },
  },
    infoRSSI: {
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        "&::before": {
            content: `'aa'`,
            width: "15px",
            height: "15px",
            backgroundColor: "#008FFB",
            marginRight: "8px",
            borderRadius: "50%",
            color: "transparent",
        },
    },
  info: {
    fontFamily: "Montserrat",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    "&::before": {
      content: `'aa'`,
      width: "15px",
      height: "15px",
      backgroundColor: "#00AAD0",
      marginRight: "8px",
      borderRadius: "50%",
      color: "transparent",
    },
  },
  devices: {
    fontFamily: "Montserrat",
    fontStyle: "italic",
    fontWeight: "300",
    fontSize: "12px",
    color: "#ABE3F0",
    marginLeft: "24px",
  },
});

export default function RadialBar(props) {
  const classes = useStyles();

  const total = props.values.reduce((accumulator, value) => accumulator + value.total , 0)
  
  var oo = {
    chart: {
      height: 300,
      type: "donut",
    },
    plotOptions: {
        pie: {
            donut: {
                size: '65%',
                labels: {
                    show: false,
                    name: {show: false}
                }
            },
        track: {
          strokeWidth: 1,
          background: "#0A232F",
        },
            
            /*
        dataLabels: {
          name: {
            show: true,
            color: "#FFFFFF",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: "normal",
          },
          value: {
            show: true,
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#FFFFFF",
          },
          total: {
            show: true,
            label: "Total",
            color: "#FFFFFF",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: "normal",
            formatter: function (w) {
              return (
                w.globals.seriesTotals.reduce((a, b) => {
                  return a + b;
                }, 0) + "%"
              );
            },
          },
        },
            */
      },
    },
    //colors: props.values.map( val => val.color),
    labels: props.values.map( val => val.title)
      //labels: {show: false}
  };

  console.log(props.values)

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs container direction="column" spacing={2}>
          <Grid item xs>
            <Typography component="h2" variant="h6">
              {props.title}
            </Typography>
          </Grid>
          <Grid item>
            {
              props.values.map( val => {
                return <div key={val.title}>
                  <p className={ classes.infoRSSI }>{`${val.title} - ${Math.round((val.total/total)*100)}%`}</p>
                  <p className={classes.devices}>{`${val.total} incidents`}</p>
                </div>
              })
            }
          </Grid>
        </Grid>
        <Grid item xs={8}>
            <br/>
            <br/>
            <br/>
          <Chart
            options={oo}
            height={300}
            series={props.values.map( val => Math.round((val.total/total)*100))}
            type="donut"
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
